import { render, staticRenderFns } from "./RelayEdit.vue?vue&type=template&id=7fbbc630&scoped=true&"
import script from "./RelayEdit.vue?vue&type=script&lang=ts&"
export * from "./RelayEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RelayEdit.vue?vue&type=style&index=0&id=7fbbc630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbbc630",
  null
  
)

export default component.exports